var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-control" },
    [
      _c("label", [_vm._v(_vm._s(_vm.value.label))]),
      _vm._v(" "),
      _c("treeselect", {
        ref: "tree",
        attrs: {
          disableBranchNodes: true,
          options: _vm.value.children,
          placeholder: _vm.value.placeholder
        },
        on: {
          input: function($event) {
            return _vm.updateTreeFacet(_vm.value)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "option-label",
            fn: function(ref) {
              var node = ref.node
              var shouldShowCount = ref.shouldShowCount
              var count = ref.count
              var labelClassName = ref.labelClassName
              var countClassName = ref.countClassName
              return _c("label", { class: labelClassName }, [
                _vm._v("\n      " + _vm._s(node.label) + "\n    ")
              ])
            }
          }
        ]),
        model: {
          value: _vm.value.value,
          callback: function($$v) {
            _vm.$set(_vm.value, "value", $$v)
          },
          expression: "value.value"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }